import { render, staticRenderFns } from "./ConvenioPage.vue?vue&type=template&id=cb3b2216&scoped=true"
import script from "./ConvenioPage.js?v=1?vue&type=script&lang=js&external"
export * from "./ConvenioPage.js?v=1?vue&type=script&lang=js&external"
import style0 from "./ConvenioPage.vue?vue&type=style&index=0&id=cb3b2216&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3b2216",
  null
  
)

export default component.exports